import { Directive, TemplateRef, ViewContainerRef, input, effect, inject } from '@angular/core';
import { SingleBlocSkeletonComponent } from './single-bloc-skeleton.component';

@Directive({
  selector: '[appSingleBlocSkeleton]',
})
export class SingleBlocSkeletonDirective {

  private viewContainer = inject(ViewContainerRef);
  private templateRef = inject(TemplateRef<unknown>);


  readonly appSingleBlocSkeleton = input<boolean>(false);
  readonly appSingleBlocSkeletonWidth = input<string>('100%');
  readonly appSingleBlocSkeletonHeight = input<string>('1.5em');
  readonly appSingleBlocSkeletonMargin = input<string>('10px');

  readonly loadingStateToggle = effect(() => {
    const loading = this.appSingleBlocSkeleton();
    this.viewContainer.clear();

    if (loading) {
      const skeletonRef = this.viewContainer.createComponent(SingleBlocSkeletonComponent);
      skeletonRef.setInput('width', this.appSingleBlocSkeletonWidth());
      skeletonRef.setInput('height', this.appSingleBlocSkeletonHeight());
      skeletonRef.setInput('margin', this.appSingleBlocSkeletonMargin());
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  });
}
